import React from "react";

var ReplyIcon = function ReplyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.045V5.6c.002-.41-.182-.819-.548-1.131-.731-.625-1.915-.625-2.646 0L1 12l8.806 7.531c.366.313.844.469 1.323.469s.957-.156 1.323-.469c.366-.312.55-.722.548-1.131v-2.368c6.573.323 10 3.718 10 3.718 0-6.843-4.188-11.252-10-11.705z"
  }));
};

ReplyIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ReplyIcon.defaultProps.solid = true;
export default ReplyIcon;